import React from "react";

const InferencePlayground = ({
  inferencePreviewUrl,
  isRunningInference,
  inferencePredictions,
  confidenceThreshold,
  onConfidenceChange,
  onUploadClick,
  fileInputRef,
  onFileChange,
}) => (
  <section className="inference-playground">
    <div className="inference-playground__header">
      <strong>Test Model (Inference Playground)</strong>
    </div>
    <div className="inference-playground__body">
      <div className="inference-playground__grid">
        <div className="inference-playground__upload-col">
          <div
            className="inference-playground__upload-zone"
            onClick={onUploadClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && onUploadClick()}
          >
            <i className={`fa fa-upload fa-2x mb-2 ${isRunningInference ? "fa-spin" : ""}`} />
            <div className="inference-playground__upload-text">
              {isRunningInference ? "Running inference…" : "Click to upload image"}
            </div>
            <div className="inference-playground__upload-hint">
              Image will be sent to the trained model for prediction.
            </div>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept=".jpg,.jpeg,.png,.bmp,.webp"
            className="d-none"
            onChange={onFileChange}
          />
          <div className="inference-playground__slider">
            <div className="inference-playground__slider-header">
              <span>Confidence threshold</span>
              <span className="badge badge-light">{(confidenceThreshold * 100).toFixed(0)}%</span>
            </div>
            <input
              type="range"
              className="custom-range"
              min="0"
              max="1"
              step="0.01"
              value={confidenceThreshold}
              onChange={(e) => onConfidenceChange(parseFloat(e.target.value))}
            />
          </div>
        </div>
        <div className="inference-playground__preview-col">
          <div className="inference-playground__preview">
            {inferencePreviewUrl ? (
              <img src={inferencePreviewUrl} alt="Inference output" />
            ) : (
              <div className="inference-playground__preview-placeholder">
                Inference output preview
                <span>Upload an image on the left to see the annotated prediction.</span>
              </div>
            )}
          </div>
        </div>
        <div className="inference-playground__classes-col">
          <div className="inference-playground__classes">
            <div className="inference-playground__classes-title">Detected classes</div>
            {inferencePredictions?.length > 0 ? (
              <ul className="inference-playground__classes-list">
                {[...inferencePredictions]
                  .sort((a, b) => (b.confidence || 0) - (a.confidence || 0))
                  .map((p, idx) => {
                    const pct = typeof p.confidence === "number" ? p.confidence * 100 : null;
                    const above = pct !== null && p.confidence >= confidenceThreshold;
                    return (
                      <li key={`${p.classId}-${idx}`} className={above ? "" : "inference-playground__class--dimmed"}>
                        <div className="d-flex justify-content-between">
                          <span>{p.className}</span>
                          <span className="text-muted">{pct !== null ? `${pct.toFixed(1)}%` : "-"}</span>
                        </div>
                        {pct !== null && (
                          <div className="progress" style={{ height: 4 }}>
                            <div
                              className={`progress-bar ${above ? "bg-primary" : "bg-secondary"}`}
                              role="progressbar"
                              style={{ width: `${Math.min(100, Math.max(0, pct))}%` }}
                            />
                          </div>
                        )}
                      </li>
                    );
                  })}
              </ul>
            ) : (
              <div className="inference-playground__classes-empty">
                Upload an image to see predicted classes and confidences.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default InferencePlayground;
